import { useCallback, useEffect, useRef, useState, forwardRef } from 'react';
import { getCookie, validateFormFields } from '../../../utils/helper';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Select from './Select';
import { LoadingDots } from './LoadingDots';
import Input from './Input';

const findUsOptions = [
	{ value: 'wordpress', label: 'WordPress.org' },
	{ value: 'free-plugin', label: 'Free Plugin' },
	{ value: 'google', label: 'Google Search' },
	{ value: 'facebook-group', label: 'Facebook Group' },
	{ value: 'email-newsletter', label: 'Email Newsletter' },
	{ value: 'advertisement', label: 'Advertisement' },
	{ value: 'from-friend', label: 'From Friend' },
	{ value: 'online-discussion', label: 'Online Discussion' },
	{ value: 'blog-article', label: 'Blog/Article' },
	{ value: 'other', label: 'Other' },
];

export function PersonalInfo(props) {
	const {
		profile,
		billingInfo,
		setBillingInfo,
		billingInfoErrors,
		setBillingInfoErrors,
		cartData,
		recaptureTrack,
		checkValidation,
		getFieldRules,
		isLoading,
		profileLoading,
	} = props;

	const inputRef = useRef();
	const [isLoggedIn, setIsLoggedIn] = useState(profile !== undefined);

	useEffect(() => {
		if (!profileLoading && profile === undefined) {
			// inputRef.current.focus();
		}
	}, [profileLoading]);

	useEffect(() => {
		if (
			billingInfo?.edd_email?.length > 0 ||
			billingInfo?.edd_first?.length > 0
		) {
			updateRecaptureCart();
		}
	}, [billingInfo]);

	useEffect(() => {
		if (profile != undefined) {
			setIsLoggedIn(true);
		}
	}, [profile]);

	const handleEmailFillUp = e => {
		const validated = validateFormFields(
			{ email: e.target.value },
			{
				email: {
					required: true,
					email: true,
				},
			}
		);

		if (e.target.value) {
			checkValidation({ edd_email: e.target.value }, false);
		}

		if (!validated.valid) {
			return;
		}
		updateRecaptureCart();
	};

	const updateRecaptureCart = () => {
		const cartKey = getCookie('racart');
		const customer = getCookie('ra_customer_id');

		if (cartKey && customer && cartData && cartData.details) {
			let checkoutUrl = process.env.REACT_APP_BASE_URL;
			const content = btoa(
				JSON.stringify(
					cartData.details.map(
						item =>
							`${item.id}|${item.item_number.options.price_id}|1`
					)
				)
			)
				.replaceAll('+', '.')
				.replaceAll('/', '_')
				.replaceAll('=', '-');

			let newCheckoutURL = `${checkoutUrl}?racart=${cartKey}&contents=${content}`;

			if (cartData.discounts.length) {
				newCheckoutURL = `${newCheckoutURL}&discount=${cartData.discounts[0]}`;
			}

			const cart = {
				external_id: cartKey,
				grand_total: cartData.total,
				products: cartData.details.map(item => ({
					name: item.name + ' - ' + item.item_number.price_name,
					image: item.item_number.image,
					price: item.price,
					external_id: item.id,
					qty: 1,
					variant_id: item.item_number.options.price_id,
				})),
				discount_codes: cartData.discounts,
				checkout_url: `${newCheckoutURL}`,
				customer: customer,
			};
			if (billingInfo) {
				if (billingInfo.edd_first && billingInfo.edd_first.length) {
					cart.first_name = billingInfo.edd_first;
				}
				if (billingInfo.edd_last && billingInfo.edd_last.length) {
					cart.last_name = billingInfo.edd_last;
				}
				if (billingInfo.edd_email && billingInfo.edd_email.length) {
					cart.email = billingInfo.edd_email;
				}
			}
			recaptureTrack(cart);
		}
	};

	const handleInput = useCallback(
		(value, fieldName) => {
			let _value = value;
			if (fieldName === 'edd_acquisition_method') {
				_value = value?.value;
			}

			setBillingInfo(prev => ({ ...prev, [fieldName]: _value }));
			setBillingInfoErrors(prev => ({ ...prev, [fieldName]: '' }));
		},
		[isLoggedIn, setBillingInfo, setBillingInfoErrors]
	);

	const onBlur = (event, keyName) => {
		updateRecaptureCart(event);

		const value = event?.target?.value;

		if (value) {
			checkValidation({ [keyName]: event.target.value }, false);
		}
	};

	return (
		<>
			<div className="wp-checkout-personal-information-wrapper">
				<h2 className="wp-checkout-font-xl wp-checkout-section-header">
					Personal Information
				</h2>
				<div className="wp-checkout-row">
					<div className="  wp-checkout-form-cal">
						<label className="wp-checkout-font-base wp-checkout-form-name-control ">
							First Name*
						</label>
						<Input
							placeholder={'John'}
							value={billingInfo.edd_first}
							onChange={value => handleInput(value, 'edd_first')}
							onBlur={e => onBlur(e, 'edd_first')}
							error={billingInfoErrors?.edd_first}
							tabIndex={1}
							ref={inputRef}
							loading={profileLoading}
						/>
					</div>
					<div className="  wp-checkout-form-cal">
						<label className="wp-checkout-font-base wp-checkout-form-name-control">
							Last Name*
						</label>
						<Input
							placeholder={'Doe'}
							value={billingInfo.edd_last}
							onChange={value => handleInput(value, 'edd_last')}
							onBlur={e => onBlur(e, 'edd_last')}
							error={billingInfoErrors?.edd_last}
							tabIndex={2}
							loading={profileLoading}
						/>
					</div>
					<div className="  wp-checkout-form-cal">
						<label className="wp-checkout-font-base wp-checkout-form-name-control">
							Email*
						</label>
						<Input
							type="email"
							placeholder={'john@doe.com'}
							value={billingInfo.edd_email}
							onChange={value => handleInput(value, 'edd_email')}
							onBlur={handleEmailFillUp}
							error={billingInfoErrors?.edd_email}
							tabIndex={3}
							loading={profileLoading}
							disabled={isLoggedIn}
						/>
					</div>
					<div className="wp-checkout-form-cal">
						<label className="wp-checkout-font-base wp-checkout-form-name-control">
							How did you find us?*
						</label>
						<div className="wp-checkout-form-control-wrapper">
							<Select
								options={findUsOptions}
								onChange={value => {
									handleInput(
										value,
										'edd_acquisition_method'
									);
									if (value) {
										checkValidation(
											{
												edd_acquisition_method:
													value?.value,
											},
											false
										);
									}
								}}
								value={findUsOptions?.find(
									item =>
										item?.value ===
										billingInfo?.edd_acquisition_method
								)}
								isSearchable={true}
								isClearable={true}
								error={
									billingInfoErrors?.edd_acquisition_method
								}
								className="wp-checkout-acquisition-method"
								placeholder="How did you find us?"
								tabIndex={4}
							/>
						</div>
					</div>
				</div>

				{!isLoggedIn && (
					<p className="wp-checkout-font-sm auth-redirect-message">
						Already have an account?{' '}
						<Link
							to={{
								pathname: '/auth/sign-in',
								search: '?redirect=checkout',
								state: { from: '/checkout' },
							}}
						>
							Sign In
						</Link>
					</p>
				)}
			</div>
		</>
	);
}
